import { Comment } from '@cube3/common/model/schema/resources/comment';
import React, { useCallback } from 'react';
import { HBox } from '../../templates/layout/Flex';
import { Icon } from '../Icon';
import { SizeVariants } from '../../../theme/themes';
import { Typography } from '../Typography';
import { TextTrimmer } from '../TextTrimmer';

export const DataSectionComment = ({
  withSvg,
  message,
  onClick
}: {
  onClick?: () => void;
  /** Override text */
  message: string;
  withSvg?: boolean;
}) => {
  const handleClick = useCallback(
    (e) => {
      // Used to prevent the default click event from being triggered
      e.stopPropagation();
      if (onClick) {
        onClick();
      }
    },
    [onClick]
  );
  return (
    <HBox
      gap={8}
      align="center"
      justify="start"
      onClick={handleClick}
      style={{ cursor: onClick ? 'pointer' : 'default', width: '100%' }}
    >
      {withSvg ? <Icon icon="gesture" size={SizeVariants.sm} /> : null}
      <Typography variant="md" colorVariant="01">
        <TextTrimmer fullText={message} maxLength={360} />
      </Typography>
    </HBox>
  );
};
